import React, { ReactNode, useEffect, useState } from "react";
import {
  CCollapse,
  CContainer,
  CFooter,
  CImage,
  CNavbar,
  CNavbarBrand,
  CNavbarNav,
  CNavbarToggler,
  CNavItem,
  CNavLink,
} from "@coreui/react-pro";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../assets/icons/logo.png";
import { BRAND_COLOR, DARK_COLOR, SITE } from "../config/site";

interface NavBarProps {
  children: ReactNode;
}

const sections = [
  { to: "/#como-funciona", label: "Cómo funciona" },
  { to: "/#entregas", label: "Entregas" },
  { to: "/#preguntas", label: "Preguntas frecuentes" },
];

const NavBar: React.FC<NavBarProps> = ({ children }) => {
  const year = new Date().getFullYear();
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  // Al navegar: cerrar el menú móvil y llevar a la sección del enlace (o al inicio de la página)
  useEffect(() => {
    setVisible(false);
    if (location.hash) {
      document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="wrapper d-flex flex-column min-vh-100 bg-light">

      <CNavbar expand="lg" className="py-3 shadow-sm sticky-top" style={{ backgroundColor: DARK_COLOR }}>
        <CContainer className="px-3 px-md-5">

          <CNavbarBrand className="m-0 p-0">
            <Link to="/" className="d-flex align-items-center text-decoration-none">
              <CImage src={logo} height={40} alt="" className="me-2 bg-white rounded-3 p-1" />
              <span className="fs-3 fw-bold text-white">
                Domicil<span style={{ color: BRAND_COLOR }}>App</span>
              </span>
            </Link>
          </CNavbarBrand>

          <CNavbarToggler
            aria-label="Abrir menú"
            className="border-0"
            aria-expanded={visible}
            onClick={() => setVisible(!visible)}
          >
            <span className="fs-2 text-white">☰</span>
          </CNavbarToggler>

          <CCollapse className="navbar-collapse mt-3 mt-lg-0" visible={visible}>
            <CNavbarNav className="ms-auto align-items-lg-center gap-lg-2 fw-medium">
              {sections.map((section) => (
                <CNavItem key={section.to}>
                  <CNavLink component={Link} to={section.to} className="text-white-50 px-3 py-2">
                    {section.label}
                  </CNavLink>
                </CNavItem>
              ))}
              <CNavItem className="mt-2 mt-lg-0 ms-lg-2">
                <CNavLink
                  component={NavLink}
                  to="/contactus"
                  className="btn fw-bold px-4 py-2 text-white rounded-pill"
                  style={{ backgroundColor: BRAND_COLOR }}
                >
                  Ayuda
                </CNavLink>
              </CNavItem>
            </CNavbarNav>
          </CCollapse>

        </CContainer>
      </CNavbar>

      <main className="body flex-grow-1">
        {children}
      </main>

      <CFooter className="d-block text-white-50 py-5" style={{ backgroundColor: DARK_COLOR }}>
        <CContainer className="px-3 px-md-5">
          <div className="row gy-4">
            <div className="col-md-5">
              <div className="fw-bold text-white fs-4">Domicil<span style={{ color: BRAND_COLOR }}>App</span></div>
              <p className="mb-0 mt-2">{SITE.slogan} Domicilios y pedidos para recoger de los negocios de Chiquinquirá.</p>
            </div>
            <div className="col-6 col-md-3">
              <div className="fw-semibold text-white mb-2">Ayuda</div>
              <ul className="list-unstyled mb-0 d-flex flex-column gap-1">
                <li><Link to="/#preguntas" className="text-white-50 text-decoration-none">Preguntas frecuentes</Link></li>
                <li><Link to="/contactus" className="text-white-50 text-decoration-none">Contáctanos</Link></li>
                <li><a href={SITE.whatsappUrl} target="_blank" rel="noreferrer" className="text-white-50 text-decoration-none">WhatsApp</a></li>
                <li><a href={`mailto:${SITE.supportEmail}`} className="text-white-50 text-decoration-none">{SITE.supportEmail}</a></li>
              </ul>
            </div>
            <div className="col-6 col-md-4">
              <div className="fw-semibold text-white mb-2">Legal</div>
              <ul className="list-unstyled mb-0 d-flex flex-column gap-1">
                <li><Link to="/termsandconditions" className="text-white-50 text-decoration-none">Términos y condiciones</Link></li>
                <li><Link to="/policyprivacy" className="text-white-50 text-decoration-none">Política de privacidad</Link></li>
                {SITE.portalUrl && (
                  <li><a href={`${SITE.portalUrl}/login`} className="text-white-50 text-decoration-none">Portal para negocios</a></li>
                )}
              </ul>
            </div>
          </div>
          <hr className="border-secondary my-4" />
          <small>&copy; {year} DomicilApp · Domicilios en {SITE.serviceArea}</small>
        </CContainer>
      </CFooter>

    </div>
  );
};

export default NavBar;
